import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function CountdownTimer() {
  const [targetDate] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() + 7);
    return date.getTime();
  });
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;
      if (distance < 0) {
        clearInterval(interval);
        return;
      }
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [targetDate]);
  const timeBlocks = [{
    label: 'DÍAS',
    value: timeLeft.days
  }, {
    label: 'HORAS',
    value: timeLeft.hours
  }, {
    label: 'MIN',
    value: timeLeft.minutes
  }, {
    label: 'SEG',
    value: timeLeft.seconds
  }];
  return <div className="flex justify-center gap-1.5 md:gap-4 my-4 md:my-8" data-id="element-253">
      {timeBlocks.map((block, index) => <motion.div key={block.label} initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: index * 0.1
    }} className="flex flex-col items-center" data-id="element-254">
          <div className={`bg-red-600 text-white w-14 h-14 md:w-20 md:h-20 rounded-lg md:rounded-xl flex items-center justify-center text-xl md:text-3xl font-black shadow-lg shadow-red-600/20 border border-red-700 ${block.label === 'SEG' ? 'animate-pulse' : ''}`} data-id="element-255">
            {block.value.toString().padStart(2, '0')}
          </div>
          <span className="text-[9px] md:text-xs font-bold text-red-400 mt-1.5 tracking-wider" data-id="element-256">
            {block.label}
          </span>
        </motion.div>)}
    </div>;
}